// Export prop types for easy import in components that use this data
import PropTypes from 'prop-types';

export const onboardingDataPropTypes = PropTypes.shape({
  restId: PropTypes.string,
  completedOnboarding: PropTypes.bool,
  skippedOnboarding: PropTypes.bool,
  completedOnboardingDate: PropTypes.string,
  intendedGoal: PropTypes.number,
  onboardingNotes: PropTypes.string,
  prioritySession: PropTypes.arrayOf(PropTypes.string),
  revenueWindow: PropTypes.arrayOf(PropTypes.string),
  demandDays: PropTypes.arrayOf(PropTypes.string),
});

export const onboardingPropTypes = PropTypes.shape({
  onboarding: PropTypes.arrayOf(onboardingDataPropTypes),
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  fetching: PropTypes.bool,
  shouldFetch: PropTypes.bool,
});

export const OnboardingInputKeys = () => [
  'restId',
  'intendedGoal',
  'onboardingNotes',
  'skippedOnboarding',
  'completedOnboarding',
  'prioritySession',
  'revenueWindow',
  'demandDays',
];
